import { Component, ElementRef, EventEmitter, Output, Renderer2, ViewChild } from "@angular/core";
import * as lit from "../shared/movano-literals";
import { Table } from "primeng/table";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { MovanoService } from "../movano.service";
import { DarkModeService } from "../dark-mode.service";
import { lastValueFrom, Subscription } from "rxjs";
import { salesManagement } from "../shared/movano-interfaces";

@Component({
  selector: "app-sales-management",
  templateUrl: "./sales-management.component.html",
  styleUrls: ["./sales-management.component.scss"],
})
export class SalesManagementComponent {
  protected LITERALS = lit;
  protected selectedDate: number = 0;
  protected version = 1.12;
  protected innerWidth: any;
  protected darkMode: boolean = false;
  private darkModeSub: Subscription = new Subscription();
  protected menuDisplay: boolean = false;
  protected filterDisplay: boolean = false;
  protected searchDisplay: boolean = false;
  protected loadingSalesManagementList: boolean = true;
  protected loadingVipManagementList: boolean = true;
  protected list: boolean = true;
  protected accountType: string = "";

  protected calendarDataSelected: any;

  protected REFRESH_TIME: number = 12000;

  protected pauseAll: boolean = false;

  protected pageSelected: number = 0;
  protected firstPage: number = 0;
  protected lastPage: number = 0;
  protected rows: number = 50;

  protected actualPage: number = 1;
  protected actualPageVip: number = 1;
  protected totalPages: number = 0;
  protected totalPagesVip: number = 0;
  protected lastTimeFrameUsed: string | undefined = "";
  protected maxPagesToShow = 5;

  protected salesTimeframeTotal: number = 0;
  protected salesTotal: number = 0;
  protected vipsTotal: number = 0;
  protected selectedIndex: number = -1;

  protected valueSearch: string = "";

  protected filter_Male: boolean = false;
  protected filter_Female: boolean = false;
  protected filter_Country?: string;
  protected filter_registerDate: Date[] = [];
  protected filter_lastSync: Date[] = [];
  protected today?: Date;
  protected type: string = "salesManagement";
  items?: any[];
  selectedItem: any;
  suggestions: any[] = [];
  protected salesManagement: salesManagement[] = [];
  protected vipsManagement: salesManagement[] = [];
  // devices: deviceTable[] = [];
  filteredSalesManagement: salesManagement[] = [];
  isFiltered: boolean = false;
  protected timeZones: string[] = [];
  protected loadingData: boolean = false;
  protected daySelected?: Date;
  protected rangeSelected: Date[] = [];
  protected actualTimeZone: string = "";
  protected timeOptions: string[] = ["", "week", "month", ""];
  protected lastselectedDate: number = 0;
  protected dataAvailable: boolean = false;
  @Output() getInfo = new EventEmitter<[number, boolean, Date | Date[], string, number]>();
  @ViewChild("salesManagementTable") salesManagementTable!: Table;

  protected isEmail: boolean = false;

  protected sortedBy: string = "soNumber";
  protected sortMode: string = "desc";

  sortedColumn = "";
  sortDirection: "asc" | "desc" = "asc";

  protected selectedTab: "Sales" | "RMAs" | "VIP" = "Sales";

  constructor(
    protected dialog: MatDialog,
    protected router: Router,
    protected movanoService: MovanoService,
    private darkModeSvc: DarkModeService,
    private renderer: Renderer2,
    private el: ElementRef,
  ) {
    this.today = new Date();
  }
  async ngOnInit() {
    this.accountType = await this.movanoService.getAccountType();
    if (this.accountType === "customerSupport") {
      this.list = false;
    }
    this.darkModeSub = this.darkModeSvc.getVariable().subscribe((val: any) => {
      this.darkMode = val;
    });
    await this.getUserDetails();
    this.emitGetInfo();
    //await this.getUserList();
    let tableElement = document.getElementsByClassName("p-datatable-wrapper")[0];
    let scrollHelper = document.getElementById("mobileScroll");
    let scrollHelperLeft = document.getElementById("mobileScroll_Left");
    if (tableElement && scrollHelper) {
      tableElement.addEventListener("scroll", function () {
        if (tableElement.scrollLeft > tableElement.scrollWidth - tableElement.clientWidth - 15) {
          scrollHelper!.style.display = "none";
        } else {
          scrollHelper!.style.display = "block";
        }

        if (tableElement.scrollLeft > 15) {
          scrollHelperLeft!.style.display = "block";
        } else {
          scrollHelperLeft!.style.display = "none";
        }
      });
    } else {
      // console.log(tableElement);
      // console.log(scrollHelper);
    }
  }

  ngOnDestroy() {
    this.darkModeSub.unsubscribe();
  }

  onResize() {
    const checkboxDivs = document.querySelectorAll(".movano_checkBox") as NodeListOf<HTMLElement>;
    const checkbox = document.querySelectorAll("mat-checkbox") as NodeListOf<HTMLElement>;
    const windowWidth = window.innerWidth;
    const checkboxSize = Math.max(windowWidth / 1440, 1) * 0.85;

    checkboxDivs.forEach((cb: HTMLElement) => {
      cb.style.width = `calc(50px * ${checkboxSize})`;
    });

    checkbox.forEach((cb: HTMLElement) => {
      cb.style.transform = `scale(${checkboxSize})`;
    });
  }

  async searchUser(inputValue?: string): Promise<void> {
    const value = inputValue?.trim() || "";

    if (!value) {
      console.error("empty input value");
      return;
    }
    try {
      let response;
      let responseVip;
      if (this.selectedTab === "VIP") {
        if (/^SO\d{5}$/.test(value)) {
          responseVip = await lastValueFrom(this.movanoService.getVipsBySoNumber(this.rows, 1, value));
        } else {
          responseVip = await lastValueFrom(this.movanoService.getVipsBySoUserName(this.rows, 1, value));
        }
      }
      if (/^M\d{4,}$|^\d{4,}$/.test(value)) {
        response = await lastValueFrom(this.movanoService.getSalesManagementByPoNumber(this.rows, 1, value));
      } else if (/^SO\d{5}$/.test(value)) {
        response = await lastValueFrom(this.movanoService.getSalesManagementBySoNumber(this.rows, 1, value));
      } else {
        response = await lastValueFrom(this.movanoService.getSalesManagementBySoUserName(this.rows, 1, value));
      }

      const searchData = response.data;
      this.salesManagement = searchData.items;
      this.salesTotal = searchData.stats.filtered;
      this.totalPages = response.pagination.total;

      const searchVipData = responseVip.data;
      this.vipsManagement = searchVipData.items;
      this.vipsTotal = searchVipData.stats.filtered;
      this.totalPagesVip = responseVip.pagination.total;
    } catch (error) {
      console.error("Error:", error);
    }
  }

  goTo(_place: string) {
    this.router.navigate([_place]);
  }

  //Get user details is now only using to know if the user is logged
  async getUserDetails() {
    const user = await this.movanoService.getUser();
    if (!user) {
      this.router.navigate(["login"]);
    }
  }

  updatePaginator(data: number[]) {
    this.rows = data[0];
    this.pageSelected = data[1];
  }

  emitGetInfo(calendarData?: [any, boolean, Date | Date[], string, any]) {
    this.getInfo.emit(calendarData);
    console.log("Parent component emitting:", calendarData);
    this.loadData(calendarData);
  }

  async loadData(calendarData?: [any, boolean, Date | Date[], string, any]) {
    this.loadingVipManagementList = true;
    this.loadingSalesManagementList = true;

    if (calendarData) {
      this.lastselectedDate = this.selectedDate;

      this.selectedDate = parseInt(calendarData[0]);

      if (this.selectedDate !== 3) {
        this.daySelected = calendarData[2] as Date;
      } else {
        this.rangeSelected = calendarData[2] as Date[];
        console.log(this.rangeSelected);
      }

      this.actualTimeZone = calendarData[3];
    } else {
      this.selectedDate = 5;

      this.actualTimeZone = this.timeZones ? this.timeZones[0] : "";
    }

    this.calendarDataSelected = calendarData;
    let salesTimeFrame: string | undefined = this.lastTimeFrameUsed || "lastMonth";

    if (calendarData) {
      if (this.selectedDate === 1) {
        salesTimeFrame = "lastWeek";
      } else if (this.selectedDate === 2) {
        salesTimeFrame = "lastMonth";
      } else if (this.selectedDate === 3) {
        salesTimeFrame = "custom";
      } else if (this.selectedDate === 4) {
        salesTimeFrame = "last7Days";
      } else if (this.selectedDate === 5) {
        salesTimeFrame = "actualYear";
      } else if (this.selectedDate === 0) {
        salesTimeFrame = "today";
      } else {
        salesTimeFrame = "";
      }

      if (this.lastTimeFrameUsed !== salesTimeFrame) {
        this.actualPage = 1;
      }
      this.lastTimeFrameUsed = salesTimeFrame;
    }

    try {
      let vip;
      let sales;
      if (this.selectedDate === 3) {
        const myCalendar: any = calendarData;
        const startDate = myCalendar[2][0] as Date;
        const endDate = myCalendar[2][1] as Date;
        const startDateF = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, "0")}-${String(
          startDate.getDate(),
        ).padStart(2, "0")}`;
        const endDateF = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, "0")}-${String(
          endDate.getDate(),
        ).padStart(2, "0")}`;
        vip = await lastValueFrom(
          this.movanoService.getVips(
            this.rows,
            this.actualPageVip,
            salesTimeFrame,
            this.sortedBy,
            this.sortMode,
            startDateF,
            endDateF,
          ),
        );
        sales = await lastValueFrom(
          this.movanoService.getSalesManagement(
            this.rows,
            this.actualPage,
            salesTimeFrame,
            this.sortedBy,
            this.sortMode,
            startDateF,
            endDateF,
          ),
        );
      } else {
        vip = await lastValueFrom(
          this.movanoService.getVips(this.rows, this.actualPageVip, salesTimeFrame, this.sortedBy, this.sortMode),
        );
        sales = await lastValueFrom(
          this.movanoService.getSalesManagement(
            this.rows,
            this.actualPage,
            salesTimeFrame,
            this.sortedBy,
            this.sortMode,
          ),
        );
      }
      this.totalPagesVip = vip.pagination.total;
      this.vipsManagement = vip.data.items;
      this.salesTimeframeTotal = vip.salesCount;
      this.vipsTotal = vip.data.stats.filtered;
      this.loadingVipManagementList = false;
      this.dataAvailable = true;

      this.totalPages = sales.pagination.total;
      this.salesManagement = sales.data.items;
      this.salesTimeframeTotal = sales.data.stats.total;
      this.salesTotal = sales.data.stats.filtered;
      this.loadingSalesManagementList = false;
      this.filteredSalesManagement = this.salesManagement;
      this.dataAvailable = true;
    } catch (error) {
      console.log(error);
      this.dataAvailable = false;
    } finally {
      this.loadingData = false;
    }
  }

  toggleSort(column: string) {
    if (this.sortedBy === column) {
      this.sortMode = this.sortMode === "asc" ? "desc" : "asc";
    } else {
      this.sortedBy = column;
      this.sortMode = "desc";
    }

    this.loadData();
  }

  getDisplayedPages(): number[] {
    const pages: number[] = [];

    let startPage = Math.max(1, this.actualPage - Math.floor(this.maxPagesToShow / 2));
    let endPage = Math.min(this.totalPages, startPage + this.maxPagesToShow - 1);

    if (endPage - startPage + 1 < this.maxPagesToShow) {
      startPage = Math.max(1, endPage - this.maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }

  nextPage() {
    if (this.actualPage < this.totalPages) {
      this.actualPage++;
      this.loadData(this.calendarDataSelected);
    }
  }

  selectPage(page: number) {
    this.actualPage = page;
    this.loadData(this.calendarDataSelected);
  }

  previousPage() {
    if (this.actualPage > 1) {
      this.actualPage--;
      this.loadData(this.calendarDataSelected);
    }
  }

  isFirstPageInRange(): boolean {
    return this.getDisplayedPages().includes(1);
  }

  isLastPageInRange(): boolean {
    return this.getDisplayedPages().includes(this.totalPages);
  }

  shouldShowLeftEllipsis(): boolean {
    return this.actualPage > Math.ceil(this.maxPagesToShow / 2) + 1;
  }

  shouldShowRightEllipsis(): boolean {
    return this.actualPage < this.totalPages - Math.floor(this.maxPagesToShow / 2);
  }

  getDisplayedPagesVip(): number[] {
    const pages: number[] = [];

    let startPage = Math.max(1, this.actualPageVip - Math.floor(this.maxPagesToShow / 2));
    let endPage = Math.min(this.totalPagesVip, startPage + this.maxPagesToShow - 1);

    if (endPage - startPage + 1 < this.maxPagesToShow) {
      startPage = Math.max(1, endPage - this.maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  }

  nextPageVip() {
    if (this.actualPageVip < this.totalPagesVip) {
      this.actualPage++;
      this.loadData(this.calendarDataSelected);
    }
  }

  selectPageVip(page: number) {
    this.actualPageVip = page;
    this.loadData(this.calendarDataSelected);
  }

  previousPageVip() {
    if (this.actualPageVip > 1) {
      this.actualPageVip--;
      this.loadData(this.calendarDataSelected);
    }
  }
  isFirstPageInRangeVip(): boolean {
    return this.getDisplayedPages().includes(1);
  }

  isLastPageInRangeVip(): boolean {
    return this.getDisplayedPages().includes(this.totalPagesVip);
  }

  shouldShowLeftEllipsisVip(): boolean {
    return this.actualPageVip > Math.ceil(this.maxPagesToShow / 2) + 1;
  }

  shouldShowRightEllipsisVip(): boolean {
    return this.actualPageVip < this.totalPagesVip - Math.floor(this.maxPagesToShow / 2);
  }

  exportCSV() {
    if (this.salesManagement && this.salesManagement.length > 0) {
      const csvData = this.convertToCSV(this.salesManagement);
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "salesManagement.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("No data to export");
    }
  }

  exportCSVVip() {
    if (this.vipsManagement && this.vipsManagement.length > 0) {
      const csvData = this.convertToCSV(this.vipsManagement);
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "vipManagement.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("No data to export");
    }
  }

  convertToCSV(objArray: any[]): string {
    const array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
    let str = "";
    let row = "";

    for (const index in array[0]) {
      if (array[0].hasOwnProperty(index)) {
        // Now convert each value to a string
        const header = index + ",";
        row += header;
      }
    }

    row = row.slice(0, -1);
    str += row + "\r\n";

    for (let i = 0; i < array.length; i++) {
      let line = "";
      for (const index in array[i]) {
        if (array[i].hasOwnProperty(index)) {
          if (line !== "") line += ",";
          line += array[i][index];
        }
      }

      str += line + "\r\n";
    }
    return str;
  }

  onTabSelected(tab: string): void {
    this.selectedTab = tab as "Sales" | "RMAs" | "VIP";
    this.clearSearch();
  }

  getSizeColorStyle(productSizeId: string): { [key: string]: string } {
    switch (productSizeId) {
      case "1":
        return { color: "#001933" }; // Size 5
      case "2":
        return { color: "#054280" }; // Size 6
      case "3":
        return { color: "#0b84ff" }; // Size 7
      case "4":
        return { color: "#0dccff" }; // Size 8
      case "5":
        return { color: "#b01065" }; // Size 9
      case "6":
        return { color: "#e31482" }; // Size 10
      case "7":
        return { color: "#7797b8" }; // Size 11
      case "8":
        return { color: "#c4d9ee" }; // Size 12
      default:
        return { color: "black" }; // Default color for unknown sizes
    }
  }

  getProductSizeName(productSizeId: string): string {
    switch (productSizeId) {
      case "1":
        return "5";
      case "2":
        return "6";
      case "3":
        return "7";
      case "4":
        return "8";
      case "5":
        return "9";
      case "6":
        return "10";
      case "7":
        return "11";
      case "8":
        return "12";
      default:
        return "Unknown";
    }
  }

  getColorStyle(productColorId: string): { [key: string]: string } {
    switch (productColorId) {
      case "Silver":
        return { color: "#7797b8" }; // Silver
      case "Gold":
        return { color: "#e7c400" }; // Gold
      case "Rose Gold":
        return { color: "#f9bc95" }; // Rose Gold
      default:
        return { color: "black" }; // Default color
    }
  }

  toggleList(): void {
    this.list = !this.list; // Cambiar entre lista y gráficos
  }

  formatTrackingNumbers(trackingNumbers: string): string {
    const numbers = trackingNumbers.split("<BR>");
    const count = numbers.length;

    // Show the first number with a "+N" if there are more numbers
    return count > 1 ? `${numbers[0]} +${count - 1}` : numbers[0];
  }

  clearSearch() {
    this.valueSearch = "";
  }
}
